import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRightSquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M13 8.5L16.5 12L13 15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12H16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRightSquare;
